import React, { useEffect, useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from '../../components/ui/dialog';
import { publicApi, adminApi } from '../../api/client';
import { toast } from '../../hooks/use-toast';
import { Plus, Pencil, Trash2, Loader2 } from 'lucide-react';

const empty = { question: '', answer: '', order: 0 };

const AdminFAQ = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const load = async () => { setLoading(true); try { setItems(await publicApi.getFaqs()); } catch {} setLoading(false); };
  useEffect(() => { load(); }, []);

  const upd = (k) => (e) => setForm({ ...form, [k]: k === 'order' ? parseInt(e.target.value || 0) : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (editing) await adminApi.updateFaq(editing.id, form); else await adminApi.createFaq(form);
      toast({ title: 'Saved' }); setOpen(false); load();
    } catch { toast({ title: 'Save failed', variant: 'destructive' }); }
  };

  const del = async (item) => { if (!window.confirm('Delete this FAQ?')) return; try { await adminApi.deleteFaq(item.id); load(); } catch {} };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div><h1 className="font-serif text-3xl text-[#304b71]">FAQs</h1><p className="text-slate-500 text-sm mt-1">Homepage frequently asked questions.</p></div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button onClick={() => { setEditing(null); setForm(empty); setOpen(true); }} className="bg-[#304b71] hover:bg-[#6a8aa4] text-white"><Plus size={16} className="mr-1" /> New FAQ</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle className="font-serif text-[#304b71]">{editing ? 'Edit' : 'New'} FAQ</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-4">
              <div><Label>Question *</Label><Input required value={form.question} onChange={upd('question')} className="mt-1" /></div>
              <div><Label>Answer *</Label><Textarea required rows={5} value={form.answer} onChange={upd('answer')} className="mt-1" /></div>
              <div><Label>Order</Label><Input type="number" value={form.order} onChange={upd('order')} className="mt-1" /></div>
              <DialogFooter><Button type="button" variant="outline" onClick={() => setOpen(false)}>Cancel</Button><Button type="submit" className="bg-[#304b71] hover:bg-[#6a8aa4] text-white">Save</Button></DialogFooter>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden">
        {loading ? <div className="py-20 text-center"><Loader2 className="animate-spin inline text-[#304b71]" /></div> :
          <table className="w-full text-sm">
            <thead className="text-xs uppercase text-slate-500 bg-[#f6f8fa]"><tr><th className="text-left px-5 py-3">Question</th><th className="text-left">Order</th><th className="text-right px-5">Actions</th></tr></thead>
            <tbody>{items.map((f) => (
              <tr key={f.id} className="border-t border-slate-100">
                <td className="px-5 py-3"><div className="font-serif text-[#304b71]">{f.question}</div><div className="text-xs text-slate-500 mt-1 line-clamp-2 max-w-xl">{f.answer}</div></td>
                <td className="text-slate-600">{f.order}</td>
                <td className="text-right px-5 space-x-1"><Button size="sm" variant="outline" onClick={() => { setEditing(f); setForm(f); setOpen(true); }}><Pencil size={14} /></Button><Button size="sm" variant="outline" className="text-rose-600 border-rose-200" onClick={() => del(f)}><Trash2 size={14} /></Button></td>
              </tr>
            ))}</tbody>
          </table>
        }
      </div>
    </div>
  );
};

export default AdminFAQ;
